module.exports = __webpack_public_path__ + "media/project-management.87d229af78623e71fe8bdee1f234ef78.svg";